import { render, staticRenderFns } from "./RequestResponseCoach.vue?vue&type=template&id=723a9535&"
import script from "./RequestResponseCoach.vue?vue&type=script&lang=js&"
export * from "./RequestResponseCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports